export const SearchHistoyListCookieKey = "search_history_list";
